var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React from 'react';

import { useLoaderData } from 'react-router';
import { createColumnHelper } from '@tanstack/react-table';
import { Translate } from "../../../../I18N";

import { Table } from "../../../Components/UI";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import * as translationsAPI from "../../../api/translations";
import {
  ContextPill,
  RenderButton,
  LabelHeader,
  TypeHeader,
  ActionHeader } from "./components/TableComponents";




const columnHelper = createColumnHelper();

const translationsListLoader =
(headers) =>
async () =>
translationsAPI.get(headers);

const TranslationsList = () => {var _translations$, _translations$$contex;
  const translations = useLoaderData();

  const contexts =


  { systemContexts: [], contentContexts: [] };

  (_translations$ = translations[0]) === null || _translations$ === void 0 ? void 0 : (_translations$$contex = _translations$.contexts) === null || _translations$$contex === void 0 ? void 0 : _translations$$contex.forEach((context) => {
    const contextTranslations = _objectSpread(_objectSpread({},
    context), {}, {
      rowId: context.id });


    if (!contextTranslations.values || Object.keys(contextTranslations.values).length === 0) {
      return undefined;
    }

    if (contextTranslations.type === 'Uwazi UI') {
      return contexts.systemContexts.push(_objectSpread({}, contextTranslations));
    }

    return contexts.contentContexts.push(_objectSpread({}, contextTranslations));
  });

  const columns = [
  columnHelper.accessor('label', {
    header: LabelHeader,
    meta: { headerClassName: 'w-1/3' }
  }),
  columnHelper.accessor('type', {
    header: TypeHeader,
    cell: ContextPill,
    meta: { headerClassName: 'w-2/3' }
  }),
  columnHelper.accessor('id', {
    header: ActionHeader,
    cell: RenderButton,
    enableSorting: false
  })];


  return (/*#__PURE__*/
    _jsx("div", { className: "w-full h-full overflow-y-auto", "data-testid": "settings-translations" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Translations" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { "data-testid": "translations" }, void 0, /*#__PURE__*/
    _jsx(Table, {
      columns: columns,
      data: contexts.systemContexts,
      header: /*#__PURE__*/
      _jsx(Translate, { className: "text-base font-semibold text-left text-gray-900 bg-white" }, void 0, "System translations"

      ),

      defaultSorting: [{ id: 'label', desc: false }] }
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "mt-4", "data-testid": "content" }, void 0, /*#__PURE__*/
    _jsx(Table, {
      columns: columns,
      data: contexts.contentContexts,
      header: /*#__PURE__*/
      _jsx(Translate, { className: "text-base font-semibold text-left text-gray-900 bg-white" }, void 0, "Content translations"

      ),

      defaultSorting: [{ id: 'label', desc: false }] }
    )
    )
    )
    )
    ));

};


export { TranslationsList, translationsListLoader };